
import {
  SiWindows,
  SiPlaystation,
  SiXbox,
  SiNintendoswitch,
  SiApple,
  SiAppstore,
  SiGoogleplay,
 } from 'react-icons/si'

//  const pc = <SiWindows />

//  const playstation =  <SiPlaystation />
 
//  const xbox = <SiXbox />
 
//  const nintendo = <SiNintendoswitch /> 
 
//  const mac = <SiApple />
 
//  const ios = <SiAppstore />
 
//  const android = <SiGoogleplay />

const platforms = {
  pc : <SiWindows /> ,
  playstation : <SiPlaystation /> ,
  xbox : <SiXbox /> ,
  nintendo : <SiNintendoswitch /> ,
  mac : <SiApple /> ,
  ios : <SiAppstore /> ,
  android : <SiGoogleplay /> }

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  platforms
}